import { $methodKey } from "./consts";
import { set } from "lodash-es";
import { arrayRemove } from "../../../tools/lang";
import { METHOD_TYPES } from "../../stateCommon/consts";
import { getMethodReturnValue } from "./getMethodReturnValue";
export async function set$MethodsSchema(instance, method, options = {}) {
  var _method$formInfo, _instance$stateSchema;
  const methodSchema = {
    id: method.id,
    title: method.title,
    arguments: (method.type === METHOD_TYPES.code ? method.args : method === null || method === void 0 || (_method$formInfo = method.formInfo) === null || _method$formInfo === void 0 ? void 0 : _method$formInfo.args) || [],
    isAsync: true,
    returnValue: getMethodReturnValue(instance, method)
  };
  if (method.system) {
    set(methodSchema, 'ds:system', true);
  }
  let $methods = (_instance$stateSchema = instance.stateSchema.fields) === null || _instance$stateSchema === void 0 ? void 0 : _instance$stateSchema.find(item => item.id === $methodKey);
  if (!$methods) {
    var _instance$stateSchema2;
    $methods = {
      id: $methodKey,
      hidden: true,
      title: '方法',
      type: 'object',
      methods: []
    };
    set($methods, 'uc:hiddenInDSTree', true);
    (_instance$stateSchema2 = instance.stateSchema.fields) === null || _instance$stateSchema2 === void 0 || _instance$stateSchema2.push($methods);
  }
  if (options.originMethodId) {
    var _$methods$methods;
    const index = (_$methods$methods = $methods.methods) === null || _$methods$methods === void 0 ? void 0 : _$methods$methods.findIndex(item => item.id === options.originMethodId);
    if (typeof index === 'number' && index >= 0) {
      var _$methods$methods2;
      (_$methods$methods2 = $methods.methods) === null || _$methods$methods2 === void 0 || _$methods$methods2.splice(index, 1, methodSchema);
    }
  } else {
    var _$methods$methods3;
    // todo 检查重复的id
    (_$methods$methods3 = $methods.methods) === null || _$methods$methods3 === void 0 || _$methods$methods3.push(methodSchema);
  }
}
export function delete$MethodsSchema(instance, methodId) {
  var _instance$stateSchema3, _$methods$methods4;
  const $methods = (_instance$stateSchema3 = instance.stateSchema.fields) === null || _instance$stateSchema3 === void 0 ? void 0 : _instance$stateSchema3.find(item => item.id === $methodKey);
  if (!($methods !== null && $methods !== void 0 && $methods.methods)) return;
  const target = (_$methods$methods4 = $methods.methods) === null || _$methods$methods4 === void 0 ? void 0 : _$methods$methods4.find(item => item.id === methodId);
  arrayRemove($methods.methods, target);
}
//# sourceMappingURL=set$MethodSchema.js.map
